export default __webpack_public_path__ + "static/media/daily-checkin.086d6e88.svg";